import { snowplowButtonClick } from '@analytics/snowplow/events';
import * as Styles from '@screens/lp-default/components/footer/styles';

export default function AppLinks() {
  return (
    <Styles.FooterApps>
      <Styles.FooterAppLink
        href="https://play.google.com/store/apps/details?id=com.medprescricao"
        target="_blank"
        rel="noreferrer"
        onClick={() => {
          snowplowButtonClick('store_download', '/planos', 'android');
        }}
        data-testid="link-android"
      >
        <img src="/images/default-landing-page/download-android.webp" alt="Download whitebook Android" loading="lazy" />
      </Styles.FooterAppLink>
      <Styles.FooterAppLink
        href="https://apps.apple.com/br/app/whitebook-cid-10-e-medicina/id638521744"
        target="_blank"
        rel="noreferrer"
        onClick={() => {
          snowplowButtonClick('store_download', '/planos', 'ios');
        }}
        data-testid="link-ios"
      >
        <img src="/images/default-landing-page/download-ios.webp" alt="Download whitebook iOS" loading="lazy" />
      </Styles.FooterAppLink>
    </Styles.FooterApps>
  );
}
